import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

// Espelha o backend (sistemaadm): entidade LogAlteracao + enums TipoEventoLog/AcaoLog/OrigemLog.
// Endpoint de leitura: GET logAlteracao/listar (auth por header Authorization + header
// `estabelecimento`, este ultimo injetado pelo interceptor de api.js a partir de estabelecimentoAtualCF).

export type OrigemLog = "PAINEL" | "API"

export interface LogAlteracao {
    id: number
    dataHora: string
    tipoEvento: string
    acao: string | null
    origem: OrigemLog
    estabelecimentoId: number | null
    fornecedorId: number | null
    usuarioNome: string | null
    usuarioEmail: string | null
    descricao: string | null
    // Payload livre por tipo de evento (antes/depois, ids, etc.).
    detalhes: unknown | null
    ip: string | null
}

export interface ListaLogAlteracao {
    itens: LogAlteracao[]
    pagina: number
    tamanho: number
    temMais: boolean
}

export interface FiltroLog {
    tipoEvento?: string
    dataInicio?: string // yyyy-MM-dd
    dataFim?: string // yyyy-MM-dd
    pagina?: number
    tamanho?: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

// Le o historico de alteracoes da loja em uso (resolvida pelo header `estabelecimento`),
// com filtros opcionais e paginacao. Ordenacao (data desc) e a cargo do backend.
export const obterHistoricoAlteracoes = async function (
    authorization: string,
    filtro: FiltroLog = {}
): Promise<ListaLogAlteracao | ErroApi> {
    try {
        const query = new URLSearchParams()
        if (filtro.tipoEvento) query.set("tipoEvento", filtro.tipoEvento)
        if (filtro.dataInicio) query.set("dataInicio", filtro.dataInicio)
        if (filtro.dataFim) query.set("dataFim", filtro.dataFim)
        if (filtro.pagina != null) query.set("pagina", String(filtro.pagina))
        if (filtro.tamanho != null) query.set("tamanho", String(filtro.tamanho))
        const params = query.toString() ? `?${query.toString()}` : ""

        const response = await api
            .get<ListaLogAlteracao | RespostaErroRaw>(`logAlteracao/listar${params}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return { itens: [], pagina: 0, tamanho: 0, temMais: false }
        }
        return response.data as ListaLogAlteracao
    } catch (error) {
        RegistrarLogErro(error, "obterHistoricoAlteracoes", filtro.tipoEvento ?? "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
